import { Box, Heading, Page, Paragraph } from '@zillow/constellation-10';

import LearnAboutPremiumButton from './LearnAboutPremiumButton';
import PremiumUpsell from './PremiumUpsell';
import ProductFeatureCompareTable from './ProductFeatureCompareTable';

type Props = {
  onPublishClick: (isPremium: boolean) => void;
};

const PremiumCompare = ({ onPublishClick }: Props) => {
  return (
    <div data-testid="PremiumCompare">
      <Box css={{ xxlDown: { width: '90%', margin: 'auto' }, '@media (min-width: 1440px)': { width: '100vw' } }}>
        <Page.Content
          css={{
            padding: '400',
            width: '100%',
            boxSizing: 'border-box',
            margin: '0 !important',
            marginBottom: '{spacing.-800}',
            paddingBottom: '0',
            maxWidth: '1232px',
          }}
        >
          <Heading level={4} fontFamily="heading-alt" css={{ marginBottom: '200', marginTop: '400' }}>
            Get the edge you need to fill your listing fast with premium
          </Heading>

          <Paragraph css={{ marginBottom: '400' }}>
            Receive higher quality leads, gain deeper insights on how to optimize your listing, and find your perfect
            renter even faster.
          </Paragraph>

          <Box css={{ marginBottom: { base: 0, xl: '1200' } }}>
            <ProductFeatureCompareTable onPublishClick={onPublishClick} />
          </Box>

          <Box css={{ display: { base: 'block', xxl: 'none' } }}>
            <Box css={{ marginBlock: '1200', textAlign: 'center' }}>
              <LearnAboutPremiumButton as="Button">Learn more</LearnAboutPremiumButton>
            </Box>

            <PremiumUpsell onPublishClick={onPublishClick} />
          </Box>
        </Page.Content>
      </Box>
    </div>
  );
};

export default PremiumCompare;
